import { createFrontendModule } from "@backstage/frontend-plugin-api";
import {
    createFormField,
    FormFieldBlueprint,
} from "@backstage/plugin-scaffolder-react/alpha";

import { GcpBusinessUnitsSelectField } from "./components";

const GcpBusinessUnitsSelectExtension = FormFieldBlueprint.make({
    name: "gcp-business-units-select",
    params: {
        field: async () =>
            createFormField({
                name: "GcpBusinessUnitsSelect",
                component: GcpBusinessUnitsSelectField,
            }),
    },
});

const scaffolderModuleGcpBusinessUnitsSelect = createFrontendModule({
    pluginId: "scaffolder",
    extensions: [GcpBusinessUnitsSelectExtension],
});

export default scaffolderModuleGcpBusinessUnitsSelect;
